import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ErrorHandlingService } from '../../../core/services/error-handling.service';
import { NotificationsService } from 'angular2-notifications';
import { VehicleCreationData } from '../../models/vehicle.model';
import { catchError, finalize, take, throwError } from 'rxjs';
import { ApiResponse } from '../../models/api-response.interface';
import { VehicleApiService } from '../../../core/services/api/vehicle-api.service';

@Component({
  selector: 'app-add-new-vehicle',
  templateUrl: './add-new-vehicle.component.html',
  styleUrls: ['./add-new-vehicle.component.scss'],
})
export class AddNewVehicleComponent implements OnInit {
  @Input() acceptAlreadyExists = false;
  isLoading = false;
  isSubmitLoading = false;

  constructor(
    private ref: DynamicDialogRef,
    private errorHandlingService: ErrorHandlingService,
    private notificationService: NotificationsService,
    private fb: FormBuilder,
    public config: DynamicDialogConfig,
    private vehicleApiService: VehicleApiService,
  ) {
    this.acceptAlreadyExists = this.config?.data?.acceptAlreadyExists;
  }

  ngOnInit(): void {}

  public close(payload?: any) {
    this.ref.close(payload);
  }

  cancelClicked(): void {
    this.close();
  }

  onSubmit(vehicle: VehicleCreationData): void {
    this.isLoading = true;
    this.vehicleApiService
      .create(vehicle)
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe({
        next: (result: ApiResponse) => {
          this.notificationService.success('Success', result.message);
          this.close({ vehicle: result.data });
        },
        error: (error) => {
          if (
            JSON.stringify(error?.error)?.includes(
              'The vin has already been taken',
            )
          ) {
            if (this.acceptAlreadyExists) {
              this.isLoading = true;
              this.vehicleApiService
                .getVehicleByVIN(vehicle?.vin)
                .pipe(finalize(() => (this.isLoading = false)))
                .subscribe({
                  next: (res) => {
                    this.notificationService.success(
                      'Success',
                      'The vehicle is created',
                    );
                    this.close({ vehicle: res.data });
                  },
                  error: (error: Error) => {
                    this.notificationService.error('Error', error.message);
                  },
                });
            } else {
              this.notificationService.error('Error', error.error.message);
            }
          } else {
            this.notificationService.error('Error', error.error.message);
          }
        },
      });
  }
}
